import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { orderBy } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PlanCard from '../../components/PlanCard';
// import { colors } from '../../styles';

const styles = css`
`;

class CommunityDetailPlans extends React.Component {
  constructor(props) {
    super(props);

    const increment = 8;
    this.state = {
      increment,
      limit: increment,
    };

    this.showMore = this.showMore.bind(this);
  }

  showMore() {
    this.setState({
      limit: this.state.limit + Infinity,
    });
  }

  render() {
    const { community, plans } = this.props;
    return (
      <div className={styles}>
        <div className="container">
          <div className="row pb-5 justify-content-center">
            {
              orderBy(plans, 'name').map(plan => (
                <div className="col-lg-4" key={plan._id}>
                  <PlanCard plan={plan} community={community} />
                </div>
              ))
            }
          </div>
        </div>
      </div>
    );
  }
}

CommunityDetailPlans.propTypes = {
  community: PropTypes.object.isRequired,
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData({
  community: true,
  plans: true,
})(CommunityDetailPlans);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/Plans.js